import React from "react";
import Portrait from "@ui-kit/identity/portrait";
import { Post, PostLensFactory } from "@radarly/models/posts";

interface IProps {
  post: Post;
  size?: React.ComponentProps<typeof Portrait>["size"];
  className?: string;
}

const RadarlyPostAuthorAvatar = ({ post, size, className }: IProps) => (
  <Portrait
    type="account"
    picture={PostLensFactory.create(post).getAuthorAvatar()}
    size={size}
    className={className}
  />
);

export default RadarlyPostAuthorAvatar;
